<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules" label-width="80px">
    <a-tabs v-model="tab">
      <a-tab-pane tab="用户信息" key="userInfo">
        <a-form-model-item label="账号" prop="loginName">
          <a-input v-model="form.data.loginName"/>
        </a-form-model-item>
        <a-form-model-item label="姓名" prop="userName">
          <a-input v-model="form.data.userName"/>
        </a-form-model-item>
        <a-form-model-item label="性别" prop="sex">
          <!--          <dict-select dict-code="SEX" v-model="form.data.sex"/>-->
          <dict-radio dict-code="SEX" v-model="form.data.sex"/>
        </a-form-model-item>
        <a-form-model-item label="是否有效" prop="isActive">
          <a-radio-group v-model="form.data.isActive">
            <a-radio value="YES">
              有效
            </a-radio>
            <a-radio value="NO">
              无效
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="邮箱" prop="email">
          <a-input v-model="form.data.email"/>
        </a-form-model-item>
      </a-tab-pane>
      <a-tab-pane tab="用户角色" key="roleInfo">
        <a-checkbox-group v-model="form.data.roleIds">
          <a-form-model-item :key="item.id" v-for="item in role.data">
            <a-checkbox :value="item.id">
              {{ item.name }}
            </a-checkbox>
          </a-form-model-item>
        </a-checkbox-group>
      </a-tab-pane>
    </a-tabs>
    <div style="text-align: right">
      <a-space>
        <a-button
          type="primary"
          v-if="!userId" @click="onAdd" :disabled="form.disabled">
          {{ $t('CREATE') || '创建' }}
          <i class="el-icon-loading el-icon--right" v-if="form.disabled"/>
        </a-button>
        <a-button
          type="primary"
          v-if="userId" @click="onUpdate" :disabled="form.disabled">{{ $t('UPDATE') || '创建' }}
          <i class="el-icon-loading el-icon--right" v-if="form.disabled"/>
        </a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </div>
  </a-form-model>
</template>

<script>
import {
  _queryUser,
  _addUser,
  _updateUser,
} from '@/api/sys/sysUserApi';
import {_queryRoles} from '@/api/sys/sysRoleApi';
import {
  _treeGenerator,
} from '@/api/sys/sysMenuApi';
import {
  _queryOrganizations,
} from '@/api/sys/sysOrganizationApi';
import DictRadio from '../../../components/DictRadio.vue';

async function getUser() {
  const result = await _queryUser(this.userId);
  if (result) {
    this.form.data.loginName = result.user.loginName;
    this.form.data.userName = result.user.userName;
    this.form.data.isActive = result.user.isActive;
    this.form.data.sex = result.user.sex;
    this.form.data.email = result.user.email;
    this.form.data.roleIds = result.roles.map(x => x.id);
    // this.form.data.organizationIds = result.organizations.map(x => x.id);
  }
}

async function onAdd() {
  this.form.disabled = true;
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addUser({
        loginName: this.form.data.loginName,
        userName: this.form.data.userName,
        isActive: this.form.data.isActive,
        sex: this.form.data.sex,
        email: this.form.data.email,
        roleIds: this.form.data.roleIds,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('ADD_SUCCESS'));
          this.onSubmitHandler();
        }
      }
      this.form.disabled = false;
    } else {
      this.form.disabled = false;
    }
  });
}

async function onUpdate() {
  this.form.disabled = true;
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateUser(this.userId, this.organizationId, {
        loginName: this.form.data.loginName,
        userName: this.form.data.userName,
        isActive: this.form.data.isActive,
        sex: this.form.data.sex,
        email: this.form.data.email,
        roleIds: this.form.data.roleIds,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('UPDATE_SUCCESS'));
          if (this.onSubmitHandler) {
            this.onSubmitHandler();
          }
        }
      }
    } else {
      this.form.disabled = false;
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'UserEdit',
  components: {
    DictRadio,
  },
  props: {
    userId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    userId(val) {
      if (val) {
        this.getUser();
      }
      this.form.data = {
        loginName: '',
        userName: '',
        sex: '',
        isActive: 'YES',
        email: '',
        roleIds: [],
        organizationIds: [],
      };
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getUser,
  },
  data() {
    const validateEmail = (rule, value, callback) => {
      if (value) {
        if ((/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/).test(value) === false) {
          callback(new Error('请输入正确的邮箱格式'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      tab: 'userInfo',
      role: {
        data: [],
      },
      form: {
        data: {
          loginName: '',
          userName: '',
          isActive: 'YES',
          email: '',
          sex: '',
          roleIds: [],
          organizationIds: [],
        },
        rules: {
          loginName: [{
            required: true,
            message: '请输入账号',
            trigger: 'blur',
          }],
          userName: [{
            required: true,
            message: '请输入姓名',
            trigger: 'blur',
          }],
          isActive: [{
            required: false,
            message: 'please choose isActive',
            trigger: 'blur',
          }],
          email: [
            {
              required: false,
              message: 'please input email',
              trigger: 'blur',
            }, {
              validator: validateEmail,
              trigger: 'blur',
            }],
        },
        disabled: false,
        tab: '',
      },
    };
  },
  async created() {
    this.tab = 'userInfo';
    const {content: roles} = await _queryRoles({});
    this.role.data = roles;
    const {content: organizations} = await _queryOrganizations({});
    this.role.organization = organizations
      .filter(x => !x.parentId)
      .map(x => _treeGenerator(x, organizations));
    if (this.userId) {
      this.getUser();
    }
  },
};
</script>
